import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import Dashboard from "@/pages/Dashboard";
import NewDDR from "@/pages/NewDDR";
import EditDDR from "@/pages/EditDDR";
import History from "@/pages/History";
import Settings from "@/pages/Settings";
import Destinatari from "@/pages/Destinatari";
import DestinatariDDT from "@/pages/DestinatariDDT";
import Produttori from "@/pages/Produttori";
import Ubicazioni from "@/pages/Ubicazioni";
import Specie from "@/pages/Specie";
import Causali from "@/pages/Causali";
import Report from "@/pages/Report";
import { initializeDB } from "@/services/localDatabase";

function App() {
  useEffect(() => {
    initializeDB();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="nuovo" element={<NewDDR />} />
            <Route path="modifica/:id" element={<EditDDR />} />
            <Route path="storico" element={<History />} />
            <Route path="destinatari" element={<Destinatari />} />
            <Route path="destinatari-ddt" element={<DestinatariDDT />} />
            <Route path="produttori" element={<Produttori />} />
            <Route path="ubicazioni" element={<Ubicazioni />} />
            <Route path="specie" element={<Specie />} />
            <Route path="causali" element={<Causali />} />
            <Route path="report" element={<Report />} />
            <Route path="impostazioni" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
      <PWAInstallPrompt />
    </div>
  );
}

export default App;
